import { NotecardEditorContentType } from '@/components/ContentTreeNode/ContentTreeLeafNode/NotecardsEditor/NotecardEditor/NotecardEditor.types'
import { atom } from 'recoil'

export const activeNotecardEditorContentTypeAtom =
    atom<NotecardEditorContentType>({
        key: 'activeNotecardEditorContentTypeAtom',
        default: NotecardEditorContentType.metadata,
    })
